import {
  EquipmentAuditStatus,
  EquipmentItemStatus,
  EquipmentPurchasePlanStatus,
  EquipmentTransferStatus
} from '@navio/nsdk';
import type { NoddiIconName } from 'noddi-ui-common';

export const EQUIPMENT_ITEM_STATUS_ICON: Record<EquipmentItemStatus, NoddiIconName> = {
  [EquipmentItemStatus.AVAILABLE]: 'CircleCheck',
  [EquipmentItemStatus.IN_USE]: 'User',
  [EquipmentItemStatus.MAINTENANCE]: 'Wrench',
  [EquipmentItemStatus.LOST]: 'CircleX'
};

export const EQUIPMENT_TRANSFER_STATUS_ICON: Record<EquipmentTransferStatus, NoddiIconName> = {
  [EquipmentTransferStatus.PENDING]: 'Clock',
  [EquipmentTransferStatus.COMPLETED]: 'CircleCheck',
  [EquipmentTransferStatus.REJECTED]: 'XCircle',
  [EquipmentTransferStatus.CANCELLED]: 'CircleX'
};

export const EQUIPMENT_AUDIT_STATUS_ICON: Record<EquipmentAuditStatus, NoddiIconName> = {
  [EquipmentAuditStatus.ACTIVE]: 'ScanLine',
  [EquipmentAuditStatus.COMPLETED]: 'CircleCheck',
  [EquipmentAuditStatus.CANCELLED]: 'CircleX'
};

export const EQUIPMENT_PURCHASE_PLAN_STATUS_ICON: Record<EquipmentPurchasePlanStatus, NoddiIconName> = {
  [EquipmentPurchasePlanStatus.DRAFT]: 'ClipboardList',
  [EquipmentPurchasePlanStatus.PENDING_APPROVAL]: 'Clock',
  [EquipmentPurchasePlanStatus.PURCHASING]: 'ShoppingCart',
  [EquipmentPurchasePlanStatus.RECEIVING]: 'PackageCheck',
  [EquipmentPurchasePlanStatus.COMPLETED]: 'CircleCheck'
};
